module.exports = __webpack_public_path__ + "static/media/about-2-bg.142902d7.png";